import _ from 'lodash';
import { observer } from 'mobx-react-lite';
import { useMemo } from 'react';
import { MarkdownViewer } from '../../views/common/editor/MarkdownViewer';

const BlogContentViewer = observer(({ content }: { content: string[] }) => {
    const contentMarkdown = useMemo(() => {
        let contentMarkdown = '';

        _.forEach(content, (line) => {
            contentMarkdown += `${line}\n\n`;
        });

        return contentMarkdown;
    }, [content]);

    return (
        <MarkdownViewer
            markdown={contentMarkdown}
            components={{
                img: ({ src, alt }) => (
                    <img src={src} alt={alt} className="max-h-[500px] w-full object-cover" />
                ),
            }}
        />
    );
});

export default BlogContentViewer;
